"use client";

import { Experience } from "@ninetailed/experience.js-react";
import { ReactNode } from "react";

// "use client";
// import { Experience } from "@ninetailed/experience.js-react";
// import { ReactNode } from "react";
// interface ExperienceWrapperProps {
//   id: string;
//   component: () => ReactNode;
//   experiences: any[];
//   children?: ReactNode;
//   [key: string]: any;
// }
// export default function ExperienceWrapperProps({ id, component, experiences, ...props }: ExperienceWrapperProps) {
//   console.log(`ExperienceWrapper rendering for ${id}:`, { experiences, props });
//   return <Experience id={id} component={component} experiences={experiences} {...props} />;
// }

// "use client";

// import { Experience } from "@ninetailed/experience.js-react";
// import { ReactNode } from "react";

// interface ExperienceWrapperProps {
//   id: string;
//   component: () => ReactNode;
//   experiences: any[];
//   children?: ReactNode;
//   [key: string]: any;
// }

// export default function ExperienceWrapperProps({ id, component, experiences, ...props }: ExperienceWrapperProps) {
//   console.log(`ExperienceWrapper rendering for ${id}:`, { experiences, props });

//   return <Experience id={id} component={component} experiences={experiences} {...props} />;
// }

interface ExperienceWrapperProps {
  id: string;
  component: any; // Updated to accept optional variant parameter
  experiences: any[];
  baseline?: any; // Add baseline prop
  // children?: ReactNode;
  // [key: string]: any;
}

export default function ExperienceWrapperProps({ id, component, experiences, baseline, ...props }: ExperienceWrapperProps) {
  console.log(`ExperienceWrapper rendering for ${id}:`, {
    experiences: experiences?.length || 0,
    hasBaseline: !!baseline,
    props,
  });

  // If no experiences are available, render the component directly with baseline
  if (!experiences || experiences.length === 0) {
    console.log("No experiences found, rendering component directly with baseline");
    return <>{component(baseline)}</>;
  }

  // Component wrapper that passes the current variant to the component
  const componentWrapper = (variant?: any) => {
    console.log("ComponentWrapper called with variant:", variant);
    // Pass the variant data to the component, fallback to baseline if no variant
    return component(variant || baseline);
  };

  console.log("Rendering Experience with experiences:", experiences.length);

  return <Experience id={id} component={componentWrapper} experiences={experiences} {...props} />;
}
